import { useState } from 'react';
import ReactMarkdown from 'react-markdown';
import SyntaxHighlighter from 'react-syntax-highlighter';
import { vscDarkPlus } from 'react-syntax-highlighter/dist/cjs/styles/prism';

// Separate CodeBlock component with isolated state
const CodeBlock = ({ language, codeContent }) => {
  const [isCopied, setIsCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(codeContent);
      setIsCopied(true);
      setTimeout(() => setIsCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };

  return (
    <div className="code-block">
      <div className="code-header">
        <span className="language-tag">{language}</span>
        <button
          onClick={(e) => {
            e.stopPropagation();
            handleCopy();
          }}
          className="btn btn-primary btn-border btn-xs"
          aria-label="Copy code"
          style={{ float: "right" }}
        >
          {isCopied ? (
            <>
              <span className="check-icon"><i className="fa-solid fa-check"></i> </span>
              Copied
            </>
          ) : (
            <>
              <span className="copy-icon"><i className="fa-regular fa-copy"></i> </span>
              Copy
            </>
          )}
        </button>

      </div>
      <SyntaxHighlighter
        style={vscDarkPlus}
        language={language}
        PreTag="div"
        children={codeContent}
      />
    </div>
  );
};

export default CodeBlock;